import axios from "axios";

// Contact form / app support: verifies reCAPTCHA server-side and emails us.
const postContactMessage = (token, inquiry, onSuccess, onError) => {
  const url = `${process.env.REACT_APP_CVDS_SERVICES_API_URL}/contact`;
  axios
    .post(url, { token, inquiry })
    .then((response) => {
      if (response.data === "success") {
        onSuccess();
      } else {
        onError(response.data);
      }
    })
    .catch((error) => onError(error));
};

export { postContactMessage };
